// Pop-up: change customer / tank size on all selected tips at once (one-click undo).
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.
import { bustTipCaches } from './helpers.js';
import { postJson } from '../../api.js';

export default function BulkEditModal({ bulkBusy, bulkCustomer, bulkOpen, bulkReason, bulkTankSize, refLists, refresh, selected, setBulkBusy, setBulkCustomer, setBulkOpen, setBulkReason, setBulkTankSize, setLastBulkBatch, setMsg, setSelected }) {
  return (
    <>
      {bulkOpen && (
        <div className="modal-backdrop" onClick={() => !bulkBusy && setBulkOpen(false)}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 480, maxWidth: 560 }}>
            <h3 style={{ marginTop: 0 }}>Bulk edit {selected.size} row(s)</h3>
            <div className="small" style={{ color: '#666', marginBottom: '0.75rem' }}>
              Only the fields you fill in below are applied. Leave a field blank to leave that data alone on every selected row.
            </div>
            <label className="small" style={{ display: 'block', marginBottom: '0.5rem' }}>Customer&nbsp;
              <select value={bulkCustomer} onChange={e => setBulkCustomer(e.target.value)} style={{ width: '100%' }}>
                <option value="">— leave unchanged —</option>
                {refLists.customers.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </label>
            <label className="small" style={{ display: 'block', marginBottom: '0.5rem' }}>Tank size (m³)&nbsp;
              <select value={bulkTankSize} onChange={e => setBulkTankSize(e.target.value)} style={{ width: '140px' }}>
                <option value="">— leave unchanged —</option>
                {refLists.tankSizes.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </label>
            <label className="small" style={{ display: 'block', marginBottom: '0.5rem' }}>Reason (audit log)&nbsp;
              <input value={bulkReason} onChange={e => setBulkReason(e.target.value)}
                placeholder="e.g. operator typed wrong customer name on these jobs"
                style={{ width: '100%' }} />
            </label>
            <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
              <button className="refresh-btn" disabled={bulkBusy || (!bulkCustomer && !bulkTankSize)}
                onClick={async () => {
                  if (!bulkCustomer && !bulkTankSize) return;
                  setBulkBusy(true); setMsg(null);
                  try {
                    const fields = {};
                    if (bulkCustomer) fields.customer = bulkCustomer;
                    if (bulkTankSize) fields.tankSize = bulkTankSize;
                    const ids = Array.from(selected);
                    const r = await postJson('/api/google/correct-bulk', { ids, fields, reason: bulkReason || undefined });
                    const labelBits = [];
                    if (fields.customer) labelBits.push('customer → ' + fields.customer);
                    if (fields.tankSize) labelBits.push('tank → ' + fields.tankSize);
                    const label = labelBits.join(', ');
                    setMsg('Bulk edit applied: ' + r.changed + ' changed · ' + r.skipped + ' already matched · ' + r.notFound + ' not found.');
                    if (r.changed > 0 && r.batchId) {
                      setLastBulkBatch({ batchId: r.batchId, count: r.changed, label });
                    }
                    setBulkOpen(false);
                    setSelected(new Set());
                    bustTipCaches(); await refresh();
                  } catch (e) { setMsg('Bulk edit failed: ' + e.message); }
                  finally { setBulkBusy(false); }
                }}
                style={{ background: '#7c3aed' }}>
                {bulkBusy ? 'Applying…' : 'Apply to ' + selected.size + ' row(s)'}
              </button>
              <button className="refresh-btn" onClick={() => setBulkOpen(false)} disabled={bulkBusy} style={{ background: '#888' }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
